import EpisodePage from 'features/clinical-history/components/EpisodePage';
import React from 'react';
import { ClinicalEpisode, EstadoEpisodio } from 'types/models';

const MOCK_EPISODE: ClinicalEpisode = {
  id:                     'ep-preview',
  tarjeteroId:            'tarj-1',
  codigoHc:               'HC-2026-007',
  pacienteId:             'pac-preview',
  profesionalId:          'prof-1',
  estado:                 EstadoEpisodio.EN_TRATAMIENTO,
  motivoConsulta:         'Cervicalgia postraumática tras accidente de tráfico. Contractura bilateral C4-C6.',
  diagnosticoPrincipal:   'Cervicalgia mecánica postraumática con contractura muscular paravertebral',
  codigoCie10:            'M54.2',
  diagnosticoSecundario:  'Síndrome ansioso-depresivo reactivo',
  diagnosticoDiferencial: null,
  notaApertura:           'Paciente refiere accidente el 15/04/2026. Colisión por detrás.',
  notaCierre:             null,
  fechaApertura:          '2026-04-18',
  fechaCierre:            null,
  anamnesis: {
    motivo:    'Dolor cervical postraumático',
    evolucion: 'Inicio brusco tras colisión vehicular hace 3 semanas. Mejoría parcial con analgésicos.',
    sintomas:  'Dolor cervical irradiado a hombro derecho EVA 6/10. Cefalea tensional occipital.',
  },
  signosVitales:       null,
  pruebasSolicitadas:  null,
  appointmentId:       null,
  createdAt:           '2026-04-18T09:00:00Z',
  updatedAt:           '2026-04-18T09:00:00Z',
};

export default function EpisodePagePreview() {
  return (
    <EpisodePage
      episode={MOCK_EPISODE}
      canWrite
      isAdmin={false}
      maxW='860px'
    />
  );
}
